import preset from '../preset';

export const boxBorderClass = preset.pclasses('boxBorder');

export default boxBorderClass;
